import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "HighlightedFeatureWrapper" }
const _hoisted_2 = { class: "FeatureHighlightBlockContentWrapper" }
const _hoisted_3 = { class: "FeatureHighlightBlockTitle" }
const _hoisted_4 = { class: "FeatureHighlightBlockText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.shouldFeatureHighlightBeShown)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "HighlightedFeatureBackdrop" }, null, -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default"),
          _createElementVNode("dialog", {
            ref: "featureHighlightBlock",
            class: _normalizeClass([
				'FeatureHighlightBlock',
				_ctx.elementClassName
			])
          }, [
            _createElementVNode("i", {
              class: "HighlightedFeatureCloseButton lnr-cross",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeHighlightedFeatureFlow && _ctx.closeHighlightedFeatureFlow(...args)))
            }),
            _cache[3] || (_cache[3] = _createElementVNode("i", { class: "FeatureHighlightBlockIcon lnr-magic-wand" }, null, -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.title), 1 /* TEXT */),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.content), 1 /* TEXT */)
            ]),
            (!_ctx.isFirstFeature)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: _normalizeClass([
						'Textlink',
						'PreviousFeatureButton',
						{ NonFinalFeatureButton: !_ctx.isFinalFeature }
					]),
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.navigateToPreviousFeature && _ctx.navigateToPreviousFeature(...args)))
                }, " Previous tip ", 2 /* CLASS */))
              : _createCommentVNode("v-if", true),
            _createElementVNode("button", {
              class: _normalizeClass(_ctx.isFinalFeature ? 'DriverButton FinalFeatureButton' : 'Textlink NextFeatureButton NonFinalFeatureButton'),
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.navigateToNextFeature && _ctx.navigateToNextFeature(...args)))
            }, _toDisplayString(_ctx.isFinalFeature ? 'Got it!' : 'Next tip'), 3 /* TEXT, CLASS */)
          ], 2 /* CLASS */)
        ])
      ], 64 /* STABLE_FRAGMENT */))
    : _renderSlot(_ctx.$slots, "default", { key: 1 })
}